import type { SvgProps } from '@/types/svgs/svg-types';

type SwjIconRadioBaseProps = SvgProps & {
    children: React.ReactNode;
    testId?: string;
};

export const SwjIconRadioBase = ({ width, height, children, testId }: SwjIconRadioBaseProps) => (
    <svg
        {...(testId ? { 'data-test-id': testId } : {})}
        width={width ?? 36}
        height={height ?? 36}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.9">
            <rect x="2" y="2" width="32" height="32" rx="16" fill="white" fillOpacity="0.3" />
            <g filter="url(#filter0_d_8601_70075)">
                <rect x="4" y="4" width="28" height="28" rx="14" fill="white" />
            </g>
            <rect x="6" y="6" width="24" height="24" rx="12" fill="#00F6FF" />
            <rect x="6" y="6" width="24" height="24" rx="12" fill="url(#paint0_linear_8601_70075)" fillOpacity="0.3" />
            <g clipPath="url(#clip0_8601_70075)">
                <rect opacity="0.3" x="12" y="14" width="30" height="30" rx="15" fill="white" />
            </g>
            {children}
        </g>
        <defs>
            <filter
                id="filter0_d_8601_70075"
                x="0"
                y="0"
                width="36"
                height="36"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.964706 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8601_70075" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8601_70075" result="shape" />
            </filter>
            <filter
                id="filter1_ii_8601_70075"
                x="12"
                y="12"
                width="13.0017"
                height="10.9961"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="0.25" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8601_70075" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="-0.1" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                <feBlend mode="normal" in2="effect1_innerShadow_8601_70075" result="effect2_innerShadow_8601_70075" />
            </filter>
            <linearGradient
                id="paint0_linear_8601_70075"
                x1="13.0909"
                y1="6"
                x2="23.4545"
                y2="28.9091"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#1733CF" stopOpacity="0" />
                <stop offset="1" stopColor="#1733CF" />
            </linearGradient>
            <clipPath id="clip0_8601_70075">
                <rect x="6" y="6" width="24" height="24" rx="12" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
